
//Resource Types
/// <amd-module name="Build/ApprovalsPanel/Constants" />
export const Resource_Environment = "environment";
export const Resource_Queue = "queue";
export const Resource_Repository = "repository";
export const Resource_ServiceEndPoint = "endpoint";
export const Resource_VariableGroup = "variablegroup";
export const Resource_AgentPool = "agentpool";
export const Resource_SecureFile = "securefile";

export const PreApprovalDefTypeId: string = "0F52A19B-C67E-468F-B8EB-0AE83B532C99";
export const MainApprovalDefTypeId: string = "26014962-64A0-49F4-885B-4B874119A5CC";
export const PostApprovalDefTypeId: string = "06441319-13FB-4756-B198-C2DA116894A4";

export enum EvaluationOrder {
    System = 0,
    SanityChecks = 10,
    PreChecks = 20,
    Main = 30,
    PostChecks = 40,
    Final = 50
}

export const MaxDeferralDurationInDays: number = 30;